import { Suspense } from 'react';

import { PageViewEventServer } from './page-view-event-server';
import { type PageViewEventProps } from './types';

export const PageViewEventSuspenseWrapper = (props: PageViewEventProps) => {
  return (
    <Suspense fallback={null}>
      <PageViewEventServer {...props} />
    </Suspense>
  );
};
